/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MetadataValue } from '../models/MetadataValue';
import type { SearchresultDTO } from '../models/SearchresultDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SearchAssetService {

    /**
     * @param q 
     * @param filter 
     * @param filterFields 
     * @param from 
     * @param count 
     * @param sortby 
     * @param order 
     * @returns SearchresultDTO Success
     * @throws ApiError
     */
    public static getSearchAsset(
q?: string,
filter?: Record<string, Array<string>>,
filterFields?: Array<string>,
from?: number,
count: number = 100,
sortby: string = 'score',
order: string = 'desc',
): CancelablePromise<SearchresultDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Search/Asset',
            query: {
                'q': q,
                'filter': filter,
                'filterFields': filterFields,
                'from': from,
                'count': count,
                'sortby': sortby,
                'order': order,
            },
        });
    }

    /**
     * @param name 
     * @param clientid 
     * @returns MetadataValue Success
     * @throws ApiError
     */
    public static getSearchAssetMetadatavalues(
name?: string,
clientid?: number,
): CancelablePromise<Array<MetadataValue>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Search/Asset/metadatavalues',
            query: {
                'name': name,
                'clientid': clientid,
            },
        });
    }

}
